import useFlag, { FLAGS } from "@coworker/app/src/hooks/useFlag";
import { useTranslation } from "@coworker/locales";
import { useState } from "react";
import { Navigate } from "react-router";
import Linkbar from "../../../shared/components/Linkbar/Linkbar";
import FixaButton from "../../../shared/wrappers/FixaButton/FixaButton";
import FixaLink from "../../../shared/wrappers/FixaLink/FixaLink";
import { FixaText } from "../../../shared/wrappers/FixaText/FixaText";
import { LaunchMediaUploadModal } from "../../components/LaunchMediaUploadModal/LaunchMediaUploadModal";
import {
  MediaCard,
  MediaCardProps,
} from "../../components/MediaCard/MediaCard";
import {
  ACCEPTED_ARTICLE_FILE_EXTENSIONS,
  ACCEPTED_ARTICLE_MIME_TYPES,
  ACCEPTED_FILE_EXTENSIONS,
  ACCEPTED_MIME_TYPES,
} from "../../config";
import pageStyles from "../launch-media-page.module.css";

const SERVICE_OFFICE_LAUNCH_MEDIA_PATH = "/launch-media/service-office";

const ServiceOfficeLaunchMediaPage = () => {
  const { t } = useTranslation();
  const [uploadIsOpen, setUploadIsOpen] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState<string>();

  const enableLaunchMedia = useFlag(FLAGS.ENABLE_LAUNCH_MEDIA);

  // Media for the Service office view is not served by the backend yet.
  const mediaCards: MediaCardProps[] = [];

  if (!enableLaunchMedia) {
    return <Navigate to="/home" replace />;
  }

  return (
    <main className={pageStyles["page"]}>
      <Linkbar currentLabel={t("capitalCaseLaunchMediaString")} />

      <FixaText
        tagName="h1"
        textStyle="Heading.L"
        className={pageStyles["title"]}
      >
        {t("capitalCaseLaunchMediaString")}
      </FixaText>

      <div className={pageStyles["filters-row"]}>
        <div className={pageStyles["actions"]}>
          <FixaButton
            htmlType="button"
            onClick={() => setUploadIsOpen(true)}
            text={t("uploadString")}
            type="emphasised"
          />
          <LaunchMediaUploadModal
            isOpen={uploadIsOpen}
            onClose={() => setUploadIsOpen(false)}
            onConfirmed={() =>
              setConfirmationMessage("Media import was saved successfully.")
            }
            presentationConstraints={{
              acceptedFileExtensions: ACCEPTED_FILE_EXTENSIONS,
              acceptedMimeTypes: ACCEPTED_MIME_TYPES,
            }}
            articleConstraints={{
              acceptedFileExtensions: ACCEPTED_ARTICLE_FILE_EXTENSIONS,
              acceptedMimeTypes: ACCEPTED_ARTICLE_MIME_TYPES,
            }}
          />
        </div>
      </div>

      {confirmationMessage && (
        <FixaText role="status" tagName="p">
          {confirmationMessage}
        </FixaText>
      )}

      <FixaText
        tagName="p"
        textStyle="Heading.S"
        className={pageStyles["results-count"]}
      >
        {mediaCards.length} Results
      </FixaText>

      <section className={pageStyles["grid"]} aria-label="Launch media">
        {mediaCards.map((media) => (
          <FixaLink
            key={media.id}
            to={`${SERVICE_OFFICE_LAUNCH_MEDIA_PATH}/${media.id}`}
          >
            <MediaCard {...media} />
          </FixaLink>
        ))}
      </section>
    </main>
  );
};

export default ServiceOfficeLaunchMediaPage;
